// extracted by mini-css-extract-plugin
export default {"section":"FeeDashboard_section__xX9Kl"};